import ArrowDropDownRoundedIcon from "@mui/icons-material/ArrowDropDownRounded";
import ArrowDropUpRoundedIcon from "@mui/icons-material/ArrowDropUpRounded";
import { Button, Stack, Typography } from "@mui/material";

interface Props {
  companyName: string;
  reportName: string | undefined;
  isMenuOpened: boolean;
  onOpenReportSelectorMenu: (event: React.MouseEvent<HTMLElement>) => Promise<void>;
  readonlyMode: boolean;
}

const ReportSelectorButton = ({
  companyName,
  reportName,
  onOpenReportSelectorMenu,
  isMenuOpened,
  readonlyMode,
}: Props) => {
  return (
    <Button
      aria-haspopup="true"
      aria-expanded={isMenuOpened ? "true" : undefined}
      color="secondary"
      sx={{ px: 0.75 }}
      onClick={onOpenReportSelectorMenu}
      endIcon={isMenuOpened ? <ArrowDropUpRoundedIcon /> : <ArrowDropDownRoundedIcon />}
      disabled={readonlyMode}
    >
      <Stack
        useFlexGap
        spacing={0.25}
        sx={(t) => ({
          maxWidth: t.spacing(50.5),
          color: readonlyMode ? "text.disabled" : "text.primary",
        })}
      >
        <Typography variant="h6" noWrap sx={{ textAlign: "left" }}>
          {reportName}
        </Typography>
        <Typography variant="caption" sx={{ alignSelf: "flex-start" }}>
          {companyName}
        </Typography>
      </Stack>
    </Button>
  );
};

export default ReportSelectorButton;
